import { compact } from 'lodash'
import { Trans, t } from '@lingui/macro'
import { Box, Paper, Stack, Typography } from '@mui/material'

import TextInput from '@/components/ui/inputs/TextInput'
import PageContainer from '@/components/ui/containers/PageContainer'
import Pagination from '@/components/ui/pagination/Pagination'

import PatientsTable from '../../patients/ui/PatientsTable'
import { usePatientSelection } from '../model/usePatientSelection'
import { usePatientsSearch } from '../model/usePatientsSearch'
import { MergeStep } from './MergeStep'
import { PatientSelectionCards } from './PatientSelectionCards'
import { ReviewMergeAlert } from './ReviewMergeAlert'

export function PatientsMergePage() {
  const { patients, isSearching, page, totalCount, onSearch, onPageChange } = usePatientsSearch()
  const { primaryPatient, secondaryPatient, activeStep, reset, select, unselect, swap } = usePatientSelection()

  return (
    <PageContainer>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4" gutterBottom>
            <Trans>Merge patients</Trans>
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <Trans>Select two patient records to merge them into one</Trans>
          </Typography>
        </Box>

        <MergeStep activeStep={activeStep} />
        <ReviewMergeAlert onSwapPatients={swap} resetPatientSelection={reset} primaryPatient={primaryPatient} secondaryPatient={secondaryPatient} />

        <PatientSelectionCards primaryPatient={primaryPatient} secondaryPatient={secondaryPatient} onUnselect={unselect} />

        <Paper>
          <Box p={2}>
            <TextInput fullWidth placeholder={t`Search patients by name, email, or social security...`} onChange={(e) => onSearch(e.target.value)} />
          </Box>
          <PatientsTable
            data={patients}
            loading={isSearching}
            onSelect={(patient) => select(patient._id)}
            hideActions
            selectedIds={compact([primaryPatient?._id, secondaryPatient?._id])}
          />
          <Box sx={{ display: 'flex', justifyContent: 'end', p: '10px' }}>
            <Pagination color="primary" hideRowsPerPage shape="rounded" page={page} onPageChange={onPageChange} totalItems={totalCount} />
          </Box>
        </Paper>
      </Stack>
    </PageContainer>
  )
}
